function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PeersTemplate = require('./peers.template');
var AdminPeersUI = /*#__PURE__*/function () {
  function AdminPeersUI(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.admin-peers';
    _classCallCheck(this, AdminPeersUI);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.configured = [];
    this.live = [];
    this.error = '';
    this.notice = '';
    this.loading_live = false;
  }
  return _createClass(AdminPeersUI, [{
    key: "render",
    value: function render() {
      var _this$mod$server_info;
      this.error = '';
      this.notice = '';
      this.live = [];
      if (!this.mod.server_info) {
        this.app.browser.replaceElementContentBySelector("<p class=\"admin-peers-empty\">Waiting for the server to finish authenticating this administrator.</p>", this.container);
        return;
      }
      this.configured = this.copyPeers(((_this$mod$server_info = this.mod.server_info) === null || _this$mod$server_info === void 0 || (_this$mod$server_info = _this$mod$server_info.options) === null || _this$mod$server_info === void 0 ? void 0 : _this$mod$server_info.peers) || []);
      this.refresh();
      this.loadLivePeers();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.app.browser.replaceElementContentBySelector(PeersTemplate({
        endpoint: this.serverEndpoint(),
        public_key: this.mod.server_publickey || '',
        live: this.live,
        offline: this.offlineConfigured(),
        error: this.error,
        notice: this.notice,
        loading_live: this.loading_live
      }), this.container);
      this.attachEvents();
    }
  }, {
    key: "copyPeers",
    value: function copyPeers(peers) {
      return (peers || []).map(function (p) {
        return {
          host: p.host || '',
          port: p.port,
          protocol: p.protocol || 'https',
          synctype: p.synctype || 'full'
        };
      });
    }
  }, {
    key: "serverEndpoint",
    value: function serverEndpoint() {
      var _this$mod$server_info2;
      var server = ((_this$mod$server_info2 = this.mod.server_info) === null || _this$mod$server_info2 === void 0 || (_this$mod$server_info2 = _this$mod$server_info2.options) === null || _this$mod$server_info2 === void 0 ? void 0 : _this$mod$server_info2.server) || {};
      var endpoint = server.endpoint || server;
      var protocol = endpoint.protocol || server.protocol || '';
      var host = endpoint.host || server.host || '';
      var port = endpoint.port || server.port || '';
      if (!protocol || !host || !port) {
        return '';
      }
      return "".concat(protocol, "://").concat(host, ":").concat(port);
    }
  }, {
    key: "peerKey",
    value: function peerKey(peer) {
      return "".concat(String(peer.host || '').toLowerCase(), "|").concat(String(peer.port || ''));
    }
  }, {
    key: "offlineConfigured",
    value: function offlineConfigured() {
      var _this = this;
      var live_keys = new Set(this.live.map(function (p) {
        return _this.peerKey(p);
      }));
      return this.configured.map(function (p, index) {
        return _objectSpread(_objectSpread({}, p), {}, {
          index: index
        });
      }).filter(function (p) {
        return !live_keys.has(_this.peerKey(p));
      });
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      document.querySelectorAll('.admin-copy-cmd').forEach(function (btn) {
        btn.onclick = function () {
          var cmd = btn.dataset.cmd;
          if (!cmd) {
            return;
          }
          navigator.clipboard.writeText(cmd).then(function () {
            if (typeof siteMessage === 'function') {
              siteMessage('copied to clipboard...', 2000);
            }
          });
        };
      });
      var refreshBtn = document.getElementById('admin-peers-refresh');
      if (refreshBtn) {
        refreshBtn.onclick = function () {
          return _this2.loadLivePeers();
        };
      }
      var addBtn = document.getElementById('admin-peer-add');
      if (addBtn) {
        addBtn.onclick = function () {
          return _this2.addPeer();
        };
      }
      var hostInput = document.getElementById('admin-peer-host');
      if (hostInput) {
        hostInput.onkeydown = function (e) {
          if (e.key === 'Enter') {
            _this2.addPeer();
          }
        };
      }
      document.querySelectorAll('.admin-peer-remove').forEach(function (btn) {
        btn.onclick = function () {
          var idx = parseInt(btn.dataset.index, 10);
          _this2.removePeer(idx);
        };
      });
    }
  }, {
    key: "addPeer",
    value: function addPeer() {
      var _this3 = this;
      var hostInput = document.getElementById('admin-peer-host');
      var portInput = document.getElementById('admin-peer-port');
      var protocolInput = document.getElementById('admin-peer-protocol');
      var host = ((hostInput === null || hostInput === void 0 ? void 0 : hostInput.value) || '').trim();
      var port = ((portInput === null || portInput === void 0 ? void 0 : portInput.value) || '').trim();
      var protocol = ((protocolInput === null || protocolInput === void 0 ? void 0 : protocolInput.value) || 'https').trim();
      if (host.includes('://')) {
        try {
          var url = new URL(host);
          protocol = url.protocol.replace(':', '') || protocol;
          host = url.hostname;
          if (url.port) {
            port = url.port;
          }
        } catch (err) {
          this.error = 'That does not look like a valid peer address.';
          this.notice = '';
          this.refresh();
          return;
        }
      }
      if (protocol === 'http' && !port) {
        port = '12101';
      }
      if (protocol === 'https' && !port) {
        port = '443';
      }
      if (!host || !port || protocol !== 'http' && protocol !== 'https') {
        this.error = 'A host, port, and protocol are needed to add a permanent peer.';
        this.notice = '';
        this.refresh();
        return;
      }
      var peer = {
        host: host,
        port: Number(port),
        protocol: protocol,
        synctype: 'full'
      };
      if (this.configured.some(function (p) {
        return _this3.peerKey(p) === _this3.peerKey(peer);
      })) {
        this.error = 'That peer is already in the permanent list.';
        this.notice = '';
        this.refresh();
        return;
      }
      this.configured.push(peer);
      this.savePeers('add');
    }
  }, {
    key: "removePeer",
    value: function removePeer(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this.configured.length) {
        return;
      }
      this.configured.splice(index, 1);
      this.savePeers('remove');
    }
  }, {
    key: "savePeers",
    value: function () {
      var _savePeers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(action) {
        var _this4 = this;
        var tx;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.error = '';
              this.notice = '';
              this.refresh();
              _context.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.mod.server_publickey);
            case 1:
              tx = _context.v;
              tx.msg = {
                module: 'Admin',
                request: 'update-peers',
                peers: this.configured
              };
              _context.n = 2;
              return tx.sign();
            case 2:
              this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                var _this4$mod$server_inf2;
                var res = res_tx.returnMessage();
                if (res !== null && res !== void 0 && res.err) {
                  var _this4$mod$server_inf;
                  _this4.configured = _this4.copyPeers(((_this4$mod$server_inf = _this4.mod.server_info) === null || _this4$mod$server_inf === void 0 || (_this4$mod$server_inf = _this4$mod$server_inf.options) === null || _this4$mod$server_inf === void 0 ? void 0 : _this4$mod$server_inf.peers) || []);
                  _this4.error = res.err;
                  _this4.notice = '';
                  _this4.refresh();
                  return;
                }
                if ((_this4$mod$server_inf2 = _this4.mod.server_info) !== null && _this4$mod$server_inf2 !== void 0 && _this4$mod$server_inf2.options) {
                  _this4.mod.server_info.options.peers = _this4.copyPeers(_this4.configured);
                }
                if (action === 'add' && res !== null && res !== void 0 && res.connecting) {
                  _this4.notice = 'This peer is now in the server configuration, and Saito is attempting to connect to it. If it does not appear above, use Refresh. The connection is kept across restarts.';
                } else if (action === 'add') {
                  _this4.notice = 'This peer is now in the server configuration. Saito will attempt to connect to it the next time the server starts.';
                } else {
                  _this4.notice = 'This peer has been removed from the server configuration. If it is still connected, that connection will remain until it drops or Saito restarts.';
                }
                _this4.refresh();
                _this4.loadLivePeers();
                if (typeof siteMessage === 'function') {
                  siteMessage('Peer configuration saved');
                }
              }, this.mod.server_publickey);
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function savePeers(_x) {
        return _savePeers.apply(this, arguments);
      }
      return savePeers;
    }()
  }, {
    key: "loadLivePeers",
    value: function () {
      var _loadLivePeers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this5 = this;
        var tx;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.loading_live = true;
              this.refresh();
              _context2.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.mod.server_publickey);
            case 1:
              tx = _context2.v;
              tx.msg = {
                module: 'Admin',
                request: 'list-peers'
              };
              _context2.n = 2;
              return tx.sign();
            case 2:
              this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                _this5.loading_live = false;
                var res = res_tx.returnMessage();
                if (res !== null && res !== void 0 && res.err) {
                  _this5.error = res.err;
                  _this5.live = [];
                  _this5.refresh();
                  return;
                }
                _this5.live = (res.result || []).map(function (p) {
                  var configured_index = _this5.configured.findIndex(function (c) {
                    return _this5.peerKey(c) === _this5.peerKey(p);
                  });
                  return {
                    publicKey: p.publicKey || '',
                    host: p.host || '',
                    port: p.port || '',
                    protocol: p.protocol || '',
                    synctype: p.synctype || '',
                    status: p.status || '',
                    permanent: configured_index >= 0,
                    configured_index: configured_index
                  };
                });
                _this5.refresh();
              }, this.mod.server_publickey);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function loadLivePeers() {
        return _loadLivePeers.apply(this, arguments);
      }
      return loadLivePeers;
    }()
  }]);
}();
module.exports = AdminPeersUI;